<section class="list-item-wrapper {{AutoClass}} {{classes}}">
  <div class="info-section">
    <ng-container *ngFor="let field of fields">
      <span
        class="Auto_List_Item_{{field.path}}"
        [ngClass]="field.cssClass"
        [genInterpolator]="field.displayPattern"
        [values]="item"
      >
        {{item|pluck:[field.path,field.fallbackPath]}}
      </span>
    </ng-container>
  </div>
  <div class="buttons-section" *ngIf="prioritizeAvailable">
    <i class="icon fa fa-times-circle delete Auto_Delete_{{item|pluck:[fields[0].path,fields[0].fallbackPath]}}" (click)="remove()"></i>
    <i class="icon fa fa-bars"></i>
  </div>
</section>
